import * as ccStore from './store'
import { readGuide, guideScopeFromStore } from './utils/guide-storage'

export function centralConfigModule({ store }) {
  if (store.hasModule && store.hasModule('centralConfig')) return
  store.registerModule('centralConfig', { ...ccStore, namespaced: true })
}

// Restaura o guia (drawer) persistido — o drawer sobrevive a reload de página.
//
// NÃO roda em `centralConfigModule`: o registro dos módulos acontece no
// bootstrap (`src/modules/index.js`), ANTES de o usuário ser carregado (isso
// acontece no `beforeEach` do router, via `P.getCurrentUser()`). Como a chave é
// carimbada por escritório + usuário, restaurar no boot leria a chave errada
// (`cc_guide_-1_-1`, o estado inicial de `user`) e nunca encontraria nada.
// Por isso o `main.vue` — layout que só monta com o usuário já resolvido —
// chama esta função no `created`.
export function restoreGuide({ store }) {
  const savedGuide = readGuide(guideScopeFromStore(store))
  if (savedGuide && savedGuide.open) {
    store.commit('centralConfig/SET_GUIDE', savedGuide)
  }
}
